<template>
    <rkm-modal
        :loading="loading"
        :title="`Centro de custo - ${infraestrutura.nome}`"
        large
        ref="Modal"
        hide-footer
    >
        <Form
            :infraestrutura="infraestrutura"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        infraestrutura: {},
    }),
    methods: {
        open(infraestrutura) {

            this.infraestrutura = infraestrutura

            this.$refs.Modal.show()

            this.$nextTick(() => this.$refs.Form.load())
        },
    },
}
</script>